import { styled } from '@mui/material';

export const StyledSimpleFileUploadWrap = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});
